<template>
    <Dialog :visible.sync="showDialog" :style="{ width: '450px' }" header="Reenviar Documentos" :modal="true" class="p-fluid" :closable="false">
      <transition-group name="p-messages" tag="div" class="col-12 md:col-12">
        <Message v-for="msg of messagesReenvio" :severity="msg.severity" :key="msg.content">
          {{ msg.content }}
        </Message>
      </transition-group>

      <div class="field col-9" v-if="paramInscricao.concorreVagasReservadas">
        <label for="file_laudo" class="font-bold">Autodeclaração de Pessoa com Deficiência (PcD) [*.pdf]</label>
        <input id="file_laudo" type="file" @change="onFileLaudoSelected" required="true" accept="application/pdf"/>
      </div>

      <div class="field col-9">
        <label for="file_rg" class="font-bold">Documento de identidade oficial com foto[*.pdf]</label>
        <input id="file_rg" type="file" @change="onFileRgSelected" required="true" accept="application/pdf"/>
      </div>

      <div class="field col-9" v-if="paramProcesso.tipoSelecao.estagio">
        <label for="file_matricula" class="font-bold">Declaração da faculdade [*.pdf]</label>
        <input id="file_matricula" type="file" @change="onFileMatriculaSelected" required="true" accept="application/pdf"/>
      </div>

      <div class="field col-7" v-if="paramProcesso.tipoSelecao.estagio">
        <label for="file_historico" class="font-bold">Historico escolar [*.pdf]</label>
        <input id="file_historico" type="file" @change="onFileHistoricoSelected" required="true" accept="application/pdf"/>
      </div>

      <div class="field col-9" v-if="!paramInscricao.isentoPagamento && paramProcesso.tipoSelecao.residencia">
        <label for="file_historico" class="font-bold">Comprovante de Pagamento [*.pdf]</label>
        <input id="file_historico" type="file" @change="onFileComprovantePagamento" required="true" accept="application/pdf"/>
      </div>

      <template #footer>
        <Button label="Reenviar documentos" icon="pi pi-refresh"
          class="p-button-text" @click="onConfirmarReenvioDocumento()"/>
        <Button label="Cancelar" icon="pi pi-times"
          class="p-button-text" @click="hideDialogReenviar()"/>
      </template>

      <DialogoConfirmacao :habilitar.sync="showConfirmacaoDialog"
        texto="Após reenviar os documentos pendentes a inscrição retornará para análise, não será possível reenviar documentos novamente. Deseja confirmar o envio de documentos?"
        :onConfirmar="atualizarDocumentos"/>

    </Dialog>

</template>

<script>
import { tratamentoDeErros } from "@/tratamentoDeErros";
import { validacaoFormulario } from '@/validacaoFormulario'
import http from '@/http';
import InscricaoService from '../service/InscricaoService';
import DialogoConfirmacao from "../components/alerta/DialogoConfirmacao.vue";

export default {
    components: { DialogoConfirmacao },
    mixins: [validacaoFormulario, tratamentoDeErros],

    props: {
        paramProcesso: null,
        paramInscricao: null,
        mensagemErro: null,
        reenviarDialog: { default:false },
        onCarregarDadoUsuario: Function,
    },

    data() {
        return {
            mensagemSucesso: '',
            messagesReenvio: '',
            coeficienteEscolar: 0,
            selectedFile: null,
            showDialog: false,
            showConfirmacaoDialog: false,
            processo: {
                    nome: '',
                    datHoraInicioInscricao: '',
                    datHoraFimInscricao: '',
                    coeficienteMinimo: null,
                    areas: []
            },
            inscricao: {
                selecaoEstagioId: null,
                areaId: null,
                coefic_red_escolar: 0.00,
                comprovante_red_escolar: null
            },
            dropdownAreas: []
        };
    },

    inscricaoService:null,

    watch: {
        reenviarDialog: function(val) {
            this.showDialog = val;
        },
    },

    beforeCreate(){
        this.inscricaoService = new InscricaoService();

        this.selectedFileLaudo = null;
        this.selectedFileRg = null;
        this.selectedFileMatricula = null;
        this.selectedFileHistorico = null;
    },
    methods: {
        cadastrar(){
		    console.log('efetuando inscricao ...');

            const fd = new FormData();
            fd.append('selecaoEstagioId', this.inscricao.selecaoEstagioId)
            fd.append('areaId', this.inscricao.areaId)
            fd.append('coefic_red_escolar', this.inscricao.coefic_red_escolar)

            console.log(`this.selectedFile.type: ${this.selectedFile.type}`)
            fd.append('comprovante_red_escolar', this.selectedFile)

            http.post('inscricao', fd)
                .then(resposta => {
                    console.log(` http.request: ${ http.request}`)
					console.log('Status: ' + resposta.request.status);
					alert('Inscrição realizada com sucesso')
					this.$router.push( { name: 'minha.inscricao' })
				})
                .catch(erro =>  {
					console.log(` Erro: ${erro}`);
          		})
        },

		onUpload() {
			this.$toast.add({severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000});
		},

        onFileLaudoSelected(event) {
            this.selectedFileLaudo = event.target.files[0];
        },
        onFileRgSelected(event) {
            this.selectedFileRg = event.target.files[0];
        },
        onFileMatriculaSelected(event) {
            this.selectedFileMatricula = event.target.files[0];
        },
        onFileHistoricoSelected(event) {
            this.selectedFileHistorico = event.target.files[0];
        },
        onFileComprovantePagamento(event) {
            this.selectedComprovantePagamento = event.target.files[0];
        },

        hideDialogReenviar() {
            this.$emit('update:reenviarDialog', false);
            this.showDialog = false;
        },

        onConfirmarReenvioDocumento() {
            this.showConfirmacaoDialog = true;
        },

        async atualizarDocumentos() {
            // console.log("Atualizando Documento: ", nomeDocumento, iddocumento, file);
            this.$store.state.dlgLoading = true;

            const fd = new FormData();

            if (this.selectedFileLaudo) {
                fd.append("comprovante_deficiencia", this.selectedFileLaudo);
            }

            if (this.selectedFileMatricula) {
                fd.append("comprovante_mat", this.selectedFileMatricula);
            }

            if (this.selectedFileRg) {
                fd.append("comprovante_rg", this.selectedFileRg);
            }

            if (this.selectedFileHistorico) {
                fd.append("comprovante_red_escolar", this.selectedFileHistorico);
            }

            console.log('Arquivo: ', this.selectedComprovantePagamento);
            if (this.selectedComprovantePagamento) {
                fd.append("docComprovantePagamento", this.selectedComprovantePagamento);
            }

            await this.inscricaoService.postUpdateDocumentosInscricao(this.paramInscricao.identificador, fd)
                .then(() => {
                    this.$toast.add({
                                severity: "success", summary: "Sucesso", detail: `Documentos atualizados com sucesso`,life: 3000,
                            });
                })
                .catch((erro) => {
                    this.$emit('update:mensagemErro', this.getMessagesError(erro));
                });

            this.hideDialogReenviar();
            this.onCarregarDadoUsuario();

            this.$store.state.dlgLoading = false;
        },

	}
}
</script>